import dayjs from 'dayjs';
import ListCustomized from './ListCustomized';
import { EXPERIENCE_INFO } from "../../data/resumeData";

function Experience() {
    return (
      <section className="experience fade-in">
        <h2>Experience</h2>
            {EXPERIENCE_INFO.map((experienceItem, index) => (
                <div key={index}>
                    <h3>{experienceItem.position}</h3>
                    <div className="container">
                      <h4>
                        {experienceItem.companyName}
                        {
                          experienceItem.formerInfo && <span> (acquired by {experienceItem.formerInfo.name}
                          {experienceItem.formerInfo.transitionDate != null && ' as of ' + dayjs(experienceItem.formerInfo.transitionDate).format('MMM YYYY')})</span>
                        }
                      </h4>
                      
                      <div className="date">{dayjs(experienceItem.startDate).format('MMM YYYY')} to {dayjs(experienceItem.endDate).format('MMM YYYY')}</div>
                    </div>
                    <div className="card"><ListCustomized items={experienceItem.list} /></div>
                </div>
            ))}
      </section>
    );
  }
  
  export default Experience;